function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4030",
  "data-name": "Group 4030",
  transform: "translate(1832.466 -4018.108)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4028",
  "data-name": "Group 4028",
  transform: "translate(-1824.977 4018)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2775",
  "data-name": "Rectangle 2775",
  width: 15,
  height: 3,
  rx: 1.5,
  transform: "translate(-0.489 0.108)",
  fill: "#596375"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2775-2",
  "data-name": "Rectangle 2775",
  width: 15,
  height: 3,
  rx: 1.5,
  transform: "translate(-0.489 6.108)",
  fill: "#596375"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2775-3",
  "data-name": "Rectangle 2775",
  width: 15,
  height: 3,
  rx: 1.5,
  transform: "translate(-0.489 12.108)",
  fill: "#596375"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4029",
  "data-name": "Group 4029",
  transform: "translate(-1832 4018)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2775-4",
  "data-name": "Rectangle 2775",
  width: 5,
  height: 3,
  rx: 1.5,
  transform: "translate(-0.466 0.108)",
  fill: "#596375"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2775-5",
  "data-name": "Rectangle 2775",
  width: 5,
  height: 3,
  rx: 1.5,
  transform: "translate(-0.466 6.108)",
  fill: "#596375"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2775-6",
  "data-name": "Rectangle 2775",
  width: 5,
  height: 3,
  rx: 1.5,
  transform: "translate(-0.466 12.108)",
  fill: "#596375"
})));

var SvgBurderIcon = function SvgBurderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burder-icon.18a776a7.svg";
export { ForwardRef as ReactComponent };